// extracted by mini-css-extract-plugin
export var container = "product-form-module--container--XbTqm";
export var hero = "product-form-module--hero--yl42i";
export var info = "product-form-module--info--XT6pG";